var React = require('react');

function IconArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.813.188a.457.457 0 01.28-.094c.105 0 .188.031.25.093l6.532 6.563A.297.297 0 0114 7a.297.297 0 01-.125.25l-6.531 6.563a.338.338 0 01-.25.093.457.457 0 01-.282-.094l-.625-.624a.338.338 0 01-.093-.25c0-.105.031-.198.093-.282l4.844-4.844H.375a.362.362 0 01-.266-.109A.362.362 0 010 7.437v-.875c0-.104.036-.192.11-.265a.362.362 0 01.265-.11h10.656L6.187 1.345a.457.457 0 01-.093-.282c0-.104.031-.187.093-.25l.625-.625z","fill":"currentColor","fillRule":"nonzero"}));
}

IconArrowRight.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = IconArrowRight;

IconArrowRight.default = IconArrowRight;
